const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear().toString();
  return `${day} ${month} ${year}`;
};

export const formatDateFromString = (dateString) => {
  const [day, month, year] = dateString.split("-");
  const monthStr = monthNames[month - 1];
  return `${day} ${monthStr} ${year}`;
};

export const getDateToday = (value) => {
  if (value === "original") {
    const date = new Date();
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${year}-${month}-${day}`;
  }
  const date = new Date();
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  return `${day}-${month}-${year}`;
};

export const dateTimeFieldToDate = (value) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const addSevenDays = (dateString, daysToAdd) => {
  const startDate = new Date(dateString);
  startDate.setDate(startDate.getDate() + daysToAdd);

  const year = startDate.getFullYear();
  const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
  const day = startDate.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const generateDateStringWithNumber = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const day = currentDate.getDate().toString().padStart(2, "0");

  const randomNumber = Math.floor(10000000 + Math.random() * 90000000);

  const dateString = `${year}${month}${day}`;
  const resultString = `${dateString}${randomNumber}`;

  return resultString;
};
export const remainingMs = (batasAkhir) => {
  const tanggalMulai = new Date();
  const tanggalAkhir = new Date(batasAkhir);
  const differenceInMs = tanggalAkhir - tanggalMulai;

  return differenceInMs;
};

export const remainingSeconds = (batasAkhir) => {
  const differenceInMs = remainingMs(batasAkhir);
  const secondsLeft = differenceInMs / 1000;

  return Math.ceil(secondsLeft);
};

export const remainingMinutes = (batasAkhir) => {
  const secondsLeft = remainingSeconds(batasAkhir);
  const hoursLeft = secondsLeft / 60;

  return Math.ceil(hoursLeft);
};

export const remainingHours = (batasAkhir) => {
  const minutesLeft = remainingMinutes(batasAkhir);
  const hoursLeft = minutesLeft / 60;

  return Math.ceil(hoursLeft);
};

export const remainingDays = (batasAkhir) => {
  const hoursLeft = remainingHours(batasAkhir);
  const daysLeft = hoursLeft / 24;

  return Math.ceil(daysLeft);
};

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, "0");
  const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    date
  );
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
};

export const pembilang = (nilai) => {
  nilai = Math.abs(nilai);
  var simpanNilaiBagi = 0;
  var huruf = [
    "",
    "Satu",
    "Dua",
    "Tiga",
    "Empat",
    "Lima",
    "Enam",
    "Tujuh",
    "Delapan",
    "Sembilan",
    "Sepuluh",
    "Sebelas",
  ];
  var temp = "";

  if (nilai < 12) {
    temp = " " + huruf[nilai];
  } else if (nilai < 20) {
    temp = pembilang(nilai - 10) + " Belas";
  } else if (nilai < 100) {
    simpanNilaiBagi = Math.floor(nilai / 10);
    temp = pembilang(simpanNilaiBagi) + " Puluh" + pembilang(nilai % 10);
  } else if (nilai < 200) {
    temp = " Seratus" + pembilang(nilai - 100);
  } else if (nilai < 1000) {
    simpanNilaiBagi = Math.floor(nilai / 100);
    temp = pembilang(simpanNilaiBagi) + " Ratus" + pembilang(nilai % 100);
  } else if (nilai < 2000) {
    temp = " Seribu" + pembilang(nilai - 1000);
  } else if (nilai < 1000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000);
    temp = pembilang(simpanNilaiBagi) + " Ribu" + pembilang(nilai % 1000);
  } else if (nilai < 1000000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000000);
    temp = pembilang(simpanNilaiBagi) + " Juta" + pembilang(nilai % 1000000);
  } else if (nilai < 1000000000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000000000);
    temp =
      pembilang(simpanNilaiBagi) + " Miliar" + pembilang(nilai % 1000000000);
  } else if (nilai < 1000000000000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000000000000);
    temp =
      pembilang(nilai / 1000000000000) +
      " Triliun" +
      pembilang(nilai % 1000000000000);
  }

  return temp;
};

export const getUser = () => {
  let user = localStorage.getItem("username");
  return user;
};

export const handleScrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const formatRP = (value) => {
  if (value === null || value === undefined) return value;

  let formattedValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (formattedValue.endsWith(".00")) {
    formattedValue = formattedValue.slice(0, -3);
  }
  return formattedValue;
};

export const formatInputRP = (value) => {
  const stringValue = value.toString().replace(/,/g, "");

  const parts = stringValue.split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1] || "";

  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  const formattedValue = decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;

  return formattedValue;
};
